const COUPON_TYPES = [
  { id: 'PERCENTAGE', name: 'Хувиар' },
  { id: 'FIXED', name: 'Дүнгээр' },
];

export default COUPON_TYPES;